import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AppContext } from "../Context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { strings } from "../Common/String";
import Button from "../Component/Button";
import Footer from "../footer";
import { MasterService } from "../Services/MasterService";
import { LeadService } from "../Services/LeadService";
import { PATH } from "../Common/Path";
import { getCurrentStep } from "../Common/utils";
import Header from "../Header";

function TermsConditions() {
  const {
    user,
    steps,
    setSteps,
    setLoading,
    currentStep,
    setCurrentStep,
    setHasChanges
  } = useContext(AppContext);

  const [options, setOptions] = useState([]);
  const [apiMessage, setApiMessage] = useState("");
  const history = useHistory();
  const [formData, setFormData] = useState({});
  const [cheked, setCheked] = useState(false);

  useEffect(() => {
    setHasChanges(false);
    setLoading(true);
    Promise.all([MasterService.termsConditions()])
      .then((datas) => {
        if (datas[0]) {
          let data = datas[0];
          if (data.success) setOptions(data.terms);
        }
        if (datas[1]) {
          let data = datas[1];
          setCurrentStep(getCurrentStep(data.current_step));
          if (data.success && data.tnc) {
            setCheked(true);
            setFormData({ iConfirm: true });
          } else {
            setCheked(false);
            setFormData({ iConfirm: false });
          }
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    steps.forEach((step) => {
      if (step.id === currentStep) step.status = 1;
      else if (step.id < currentStep) step.status = 2;
    });
    setSteps(steps);
  }, [currentStep]);

  const handleCheckBoxChange = (e) => {
    const checked = e.target.checked;
    setFormData((fd) => ({ ...fd, iConfirm: checked }));
    setCheked(checked);
    setApiMessage("");
    setHasChanges(true);
  };

  const nextClick = () => {
    if (formData.iConfirm) {
      const body = { mobile: user.mobile, email: user.email, tnc: true };
      setApiMessage("");
      setLoading(true);
      LeadService.postTermsConditions(body)
        .then((data) => {
          if (data.success) history.push(PATH.CREATEPASSWORD_PAGE);
          else setApiMessage(data.error);
        })
        .catch(console.error)
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <Header />
      <div className="inner pb-4">
        <div className="container">
          <div className="row">
            <div className="col-md-30 mt-6 ml-5 pl-5">
              <div className="images-add">
                <img
                  src={process.env.PUBLIC_URL + "/img/terms-illustration.png"}
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-50 ml-5">
              <div className="l-box">
                <h1 className="text-left pb-4">{strings.termsconditions}</h1>
                <div className="col-md-12">
                  <ol type="1" className="list-ad">
                    {options.map((item, index) => (
                      <li key={index} style={{ paddingLeft: "9px" }}>
                        <p>{item.condition}</p>
                      </li>
                    ))}
                  </ol>
                </div>
                <div
                  className="select-plan terms"
                  style={{ backgroundColor: "#f5f9ff" }}
                >
                  <label className="main mt-3">
                    <p>I agree to the above terms and conditions</p>
                    <input
                      type="checkbox"
                      checked={cheked}
                      onChange={handleCheckBoxChange}
                    />
                    <span className="geekmark" />
                  </label>
                </div>
                <div
                  id="txterror"
                  name="txterror"
                  className="api-errormessage text-danger mh-25"
                >
                  {apiMessage}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mh-64">
          <div className="col-11 mt-2 text-right">
            <div className="pt-3 text-right">
              <Button
                classes="inp"
                classes1={!cheked ? "disabled-button" : "buttonmystyle"}
                label={strings.nextbtn}
                btndisable={!cheked}
                click={nextClick}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TermsConditions;
